import _get from 'lodash/get';
import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { defaultContext, getInitialStyle, colors, HEIGHT, ICON_SIZE } from './snackBar.style';
import { HIDE_TIMEOUT } from './snackBar.constants';
import Icon from '../icon/icon.component';
import { NOTIFICATION_LEVEL } from '../notifications';

export class SnackBar extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Content: {
          rect: true,
          Inner: {
            Icon: {
              type: Icon,
            },
            Caption: { text: {} },
          },
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _detach() {
    if (this._hideTimeout) {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }

  push(notification) {
    if (!notification) {
      return;
    }

    const contentColor = _get(colors.text, [notification.level, this._style.colorMode]);
    const icon = notification.icon || {
      name: notification.level === NOTIFICATION_LEVEL.SUCCESS ? 'CheckFocused' : 'Info',
    };

    this.tag('Content').patch({
      smooth: {
        color: _get(colors.background, [notification.level, this._style.colorMode]),
        y: 0,
      },
      Inner: {
        Icon: {
          color: contentColor,
          iconData: {
            picto: icon,
            viewBox: {
              h: ICON_SIZE[this._style.screenSize],
            },
          },
        },
        Caption: {
          text: {
            text: notification.text,
            textColor: contentColor,
          },
        },
      },
    });

    if (this._hideTimeout) {
      clearTimeout(this._hideTimeout);
    }
    this._hideTimeout = setTimeout(() => {
      this.tag('Content').setSmooth('y', HEIGHT[this._style.screenSize]);
    }, HIDE_TIMEOUT);
  }
}
